import { useStaticCallback } from '@sparemin/blockhead';
import { useEffect } from 'react';

type UseAdjustCropClickOutsideProps = {
  isDisabled?: boolean;
  ignoreElements?: HTMLElement[];
  onClickOutside?: () => void;
};

// TODO this exists in eddy - put it in blockhead and use here?
export default function useAdjustCropClickOutside({
  ignoreElements,
  isDisabled,
  onClickOutside,
}: UseAdjustCropClickOutsideProps) {
  const staticOnClickOutside = useStaticCallback(onClickOutside);

  useEffect(() => {
    if (isDisabled) {
      return undefined;
    }

    const handleEvent = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      if (ignoreElements?.some(element => element.contains(target))) {
        return;
      }

      staticOnClickOutside?.();
    };

    document.addEventListener('pointerdown', handleEvent);

    return () => {
      document.removeEventListener('pointerdown', handleEvent);
    };
  }, [ignoreElements, isDisabled, staticOnClickOutside]);
}
